import Vue from 'vue'
import App from './App.vue'
import SandUI from '@fe/sand-ui';
import '@fe/sand-ui/lib/styles/theme-white.css'; // 引入默认白色主题
import './assets/css/common.scss' // site公共样式
import router from './router'
import SaIcon from '@/index.js'
import "@/assets/iconfont.less";
import '@/packages/vue';

Vue.use(SandUI);
Vue.use(SaIcon); // 顺序要在 SandUI 后面

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
